import tw, { styled } from 'twin.macro'
import React, { Component } from 'react'
import { Link } from 'gatsby'

const BackgroundWrapper = styled('div')`
  ${tw`bg-gray-50 pb-6`}
`

const Wrapper = styled('footer')`
  ${tw`container mx-auto px-4 sm:px-32 font-light`}
`

const Container = styled('div')`
  ${tw`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4`};
`

const Icons = styled('div')`
  ${tw`flex justify-center`}
`

const IconLink = styled('a')`
  ${tw`text-xl border border-solid border-gray-400 rounded-lg w-12 h-12 text-center mx-4 my-6 text-gray-600 flex justify-center items-center no-underline hover:bg-gray-200`};
`

const Headline = styled('h2')`
  ${tw`text-base font-bold mb-2`};
`

const Section = styled('div')`
  a, button {
    ${tw`block text-gray-600 mb-1 no-underline hover:text-red-500`}
  }
`

const Copyright = styled('div')`
  ${tw`text-xs text-gray-500 text-center my-8`};
`

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uptimeStatusColor: null
    }
  }

  componentDidMount() {
    this.refreshUptimeStatus();
  }

  render() {
    return (
      <div>
        <BackgroundWrapper>
          <Wrapper>
            <Icons>
              <IconLink href="https://twitter.com/geocodio" target="_blank" rel="noopener noreferrer" title="Twitter Icon"><i className="fa fa-twitter" /></IconLink>
              <IconLink href="https://www.youtube.com/channel/UCYG54upt1Jo8bUYqzQjBTRQ" target="_blank" rel="noopener noreferrer" title="Youtube Icon"><i className="fa fa-youtube" /></IconLink>
              <IconLink href="mailto:support@geocod.io" target="_blank" rel="noopener noreferrer"><i className="fa fa-envelope" title="Email Icon" /></IconLink>
            </Icons>
            <Container>
              <Section>
                <Headline>Product</Headline>
                <a href="/guides/">Overview</a>
                <a href="/docs/">API</a>
                <Link to="/upload/">Spreadsheet Upload</Link>
                <Link to="/cli/">Geocodio CLI</Link>
                <Link to="/enterprise/">Geocodio Enterprise</Link>
                <Link to="/features/maps/">Geocodio Maps</Link>
              </Section>
              <Section>
                <Headline>Company</Headline>
                <Link to="/about/">About</Link>
                <Link to="/terms-of-use/">Terms of Use</Link>
                <Link to="/security/">Security</Link>
                <Link to="/gdpr/">Privacy</Link>
                <Link to="/data-retention-policy/">Data Retention Policy</Link>
                <Link to="/data-sources/">Data Sources</Link>
                <Link to="/dmca/">DMCA</Link>
                <Link to="/updates/">Updates</Link>
                <Link to="/code-and-coordinates/">Code and Coordinates</Link>
                <Link to="/contact/">Contact Us</Link>
              </Section>
              <Section>
                <Headline>Customers</Headline>
                <Link to="/financial-services/">Banks &amp; Insurance</Link>
                <Link to="/political-and-civic-data/">Politics &amp; Non-Profits</Link>
                <Link to="/healthcare/">Healthcare</Link>
                <Link to="/real-estate-geocoding/">Real Estate</Link>
                <Link to="/academia/">Academia</Link>
                <Link to="/fleet-management-geocoding/">Fleet Management</Link>
                <Link to="/geographic-data-for-journalists/">Journalism</Link>
                <Link to="/geo-analytics/">Data Analytics</Link>
                <Link to="/customers/">More...</Link>
              </Section>
              <Section>
                <Headline>Features</Headline>
                <Link to="/address-cleanup/">Address Parsing, Completion, &amp; Normalization</Link>
                <Link to="/add-zip-4-to-addresses/">ZIP+4 and Carrier Routes</Link>
                <Link to="/add-census-demographic-data-income-stats-and-more-with-one-click/">US &amp; Canadian Census Data</Link>
                <Link to="/address-or-coordinates-to-congressional-districts/">Congressional Districts &amp; Contact Information</Link>
                <Link to="/how-to-find-ridings-for-an-address/">Ridings</Link>
                <Link to="/find-state-legislative-districts-for-addresses/">State Legislative Districts</Link>
                <Link to="/find-school-districts-for-addresses/">School Districts</Link>
                <Link to="/time-zone-data/">Time Zones</Link>
                <Link to="/latitude-longitude-coordinates-to-addresses/">Coordinates to Addresses</Link>
              </Section>
              <Section>
                <Headline>Tools</Headline>
                <Link to="/try/">Single Address Lookup</Link>
                <a href="/geoids/">List of GeoIDs</a>
              </Section>
              <Section>
                <Headline>Support</Headline>
                <a href="https://status.geocod.io">
                  {this.state.uptimeStatusColor && <i className="fa fa-circle" style={{ color: this.state.uptimeStatusColor }} />}
                  {' '}
                  System Status
                </a>
                <a href="/docs/">API Documentation</a>
                <Link to="/guides/">Guides</Link>
                <Link to="/how-to-use-geocodio/">Tutorials</Link>
                <a href="https://dash.geocod.io/report/">Report Address Issue</a>
                <Link to="/contact/">Contact Support</Link>
              </Section>
            </Container>
          </Wrapper>
        </BackgroundWrapper>
        <Copyright>
          Copyright &copy; 2014-{new Date().getFullYear()} Dotsquare LLC, Norfolk, Virginia. All rights reserved.
        </Copyright>
      </div>
    );
  }

  refreshUptimeStatus() {
    const url = 'https://status.geocod.io/api/components';

    fetch(url)
      .then(response => response.json())
      .then(response => {
        const apiOnline = response[0]?.status === 'Operational';
        const dashOnline = response[1]?.status === 'Operational';

        let colorStatus = '#efc778';
        if (apiOnline && dashOnline) {
            colorStatus = '#b5e08d';
        } else if (!apiOnline && !dashOnline) {
            colorStatus = '#f4665f';
        }

        this.setState({
          uptimeStatusColor: colorStatus
        });
      }).catch(err => {});

    setTimeout(30000, this.refreshUptimeStatus);
  }
}

export default Footer
